import React from 'react';
import { Suspense, useEffect, useState } from 'react';
import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';
import Callback from '../Auth/Callback';
import Loader from '../Layout/Loader';
import { authRoutes } from './AuthRoutes';
import LayoutRoutes from '../Route/LayoutRoutes';
import Signin from '../Auth/Signin';
import PrivateRoute from './PrivateRoute';
import ForgotPwd from '../Auth/ForgotPwd';
import ResetPwd from '../Auth/ResetPwd';
import VerifyOtp from '../Auth/ForgotPwd/VerifyOtp';
import RedirectLoader from '../Components/Payment/RedirectLoader';
// setup fake backend
// configureFakeBackend();
const Routers = () => {
  const [currentUser, setCurrentUser] = useState(false);
  const [authenticated, setAuthenticated] = useState(false);
  const jwt_token = localStorage.getItem('token');

  useEffect(() => {
    let abortController = new AbortController();
    // const requestOptions = { method: 'GET', headers: authHeader() };
    // fetch('/users', requestOptions).then(handleResponse);
    // firebase_app.auth().onAuthStateChanged(setCurrentUser);
    setAuthenticated(JSON.parse(localStorage.getItem('authenticated')));
    console.ignoredYellowBox = ['Warning: Each', 'Warning: Failed'];
    console.disableYellowBox = true;
    return () => {
      abortController.abort();
    };
  }, []);

  return (
    // <Auth0Provider domain={auth0.domain} clientId={auth0.clientId} redirectUri={auth0.redirectUri}>
      <BrowserRouter basename={'/'}>
        <>
          <Suspense fallback={<Loader />}>
            <Routes>
              <Route path={'/'} element={<PrivateRoute />}>
                {currentUser !== null || authenticated || jwt_token ? (
                  <>
                    <Route exact path={`${process.env.PUBLIC_URL}`} element={<Navigate to={`${process.env.PUBLIC_URL}/${localStorage.getItem('homePage')}`} />} />
                    <Route exact path={`/`} element={<Navigate to={`${process.env.PUBLIC_URL}/${localStorage.getItem('homePage')}`} />} />
                  </>
                ) : (
                  ''
                )}
                <Route path={`/*`} element={<LayoutRoutes />} />
              </Route>
              <Route path={`${process.env.PUBLIC_URL}/callback`} render={() => <Callback />} />
              <Route exact path={`${process.env.PUBLIC_URL}/login`} element={<Signin />} />
              <Route exact path={`${process.env.PUBLIC_URL}/forgot-pwd`} element={<ForgotPwd />} />
              <Route exact path={`${process.env.PUBLIC_URL}/resetpassword/:userKey`} element={<ResetPwd />} />
              <Route exact path={`${process.env.PUBLIC_URL}/verifyotp`} element={<VerifyOtp />} />
              <Route exact path={`${process.env.PUBLIC_URL}/payment/redirect`} element={<RedirectLoader />} />
              {authRoutes.map(({ path, Component }, i) => (
                <Route path={path} element={Component} key={i} />
              ))}
            </Routes>
          </Suspense>
        </>
      </BrowserRouter>
    // </Auth0Provider>
  );
};

export default Routers;
